(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2253],{

/***/ 85333:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fastdebtconsolidation",
      function () {
        return __webpack_require__(7253);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ FastDebtConsolidationHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_fastdebtconsolidation_mainBanner_mainBanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87532);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _components_fastdebtconsolidation_whatDebtRelief__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26192);
/* harmony import */ var _components_shared_offersList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33124);
/* harmony import */ var _components_layouts_fastDebtConsolidationWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7724);
/* harmony import */ var _components_fastdebtconsolidation_howDebtWorks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63763);
/* harmony import */ var _components_fastdebtconsolidation_disadvantagesDebtSettlement__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83388);
/* harmony import */ var _components_fastdebtconsolidation_debtSettlement__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49658);










var __N_SSP = true;
function FastDebtConsolidationHome() {
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_fastDebtConsolidationWrapper__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_fastdebtconsolidation_mainBanner_mainBanner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                style: {
                    padding: "0 15px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_offersList__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    offers: domain?.defaultOffers
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_fastdebtconsolidation_whatDebtRelief__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_fastdebtconsolidation_debtSettlement__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_fastdebtconsolidation_howDebtWorks__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_fastdebtconsolidation_disadvantagesDebtSettlement__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,12672,7724,30686,49774,92888,40179], function() { return __webpack_exec__(85333); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);